export default __webpack_public_path__ + "static/media/Strip01.c6d26563.png";